import React from 'react';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/es-us';

import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

const ProjectDetails = props => {
  const { auth, project } = props;
  if (!auth.uid) return <Redirect to='/signin' />;

  if (project) {
    return (
      <div>
        <Card>
          <Card.Header as='h5'>{project.title}</Card.Header>
          <Card.Body>
            <blockquote className='blockquote mb-0'>
              <p>{project.content}</p>
              <footer className='blockquote-footer'>
                Autor{' '}
                <cite title='Source Title'>
                  {project.authorFirstName} {project.authorLastName}
                </cite>
                {' - '}
                {moment(project.createdAt.toDate())
                  .locale('es')
                  .calendar()}
              </footer>
            </blockquote>
          </Card.Body>
        </Card>
      </div>
    );
  } else {
    return (
      <div>
        <Container>
          <Row className='justify-content-center'>
            <div className='col-md-4'>
              <div className='d-flex align-items-center text-primary'>
                <strong>Cargando...</strong>
                <div className='spinner-grow ml-auto' role='status' aria-hidden='true'></div>
              </div>
            </div>
          </Row>
        </Container>
      </div>
    );
  }
};

const mapStateToProps = (state, ownProps) => {
  // console.log(state);
  const id = ownProps.match.params.id;
  const projects = state.firestore.data.projects;
  const project = projects ? projects[id] : null;
  return {
    project: project,
    auth: state.firebase.auth,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect([{ collection: 'projects' }]),
)(ProjectDetails);
